import { SiteContainer, SiteMockSlot } from '../SiteUi';

const SCENES = [
  {
    title: 'Cliente sumiu',
    line: 'Quando foi mesmo a última troca de óleo dele?',
    visual: (
      <SiteMockSlot tone="dark">
        <p className="text-white/50">ABC-1234 · João</p>
        <p className="mt-2 text-white">Última visita</p>
        <p className="mt-1 font-os text-white/40">—</p>
      </SiteMockSlot>
    ),
  },
  {
    title: 'Cobrança atrasou',
    line: 'Alguém chegou a chamar esse cliente?',
    visual: (
      <SiteMockSlot tone="dark">
        <p className="text-white">OS-1038 · Marina</p>
        <p className="mt-2 font-os text-[#f5821f]">R$ 420,00</p>
        <p className="mt-1 text-white/50">pendente · 14 dias</p>
      </SiteMockSlot>
    ),
  },
  {
    title: 'Caixa não fecha',
    line: 'Está na planilha, no sistema ou no caderno?',
    visual: (
      <SiteMockSlot tone="dark">
        <p className="text-white">Saldo do dia</p>
        <div className="mt-3 grid grid-cols-3 gap-1 text-center text-[11px]">
          {['planilha', 'caderno', 'sistema'].map((source) => (
            <span key={source} className="rounded-md border border-white/15 py-2 text-white/60">
              {source}
            </span>
          ))}
        </div>
      </SiteMockSlot>
    ),
  },
];

export function SitePains() {
  return (
    <section className="bg-[#0e1a28] py-20 text-white sm:py-28">
      <SiteContainer>
        <h2 className="max-w-[16ch] font-display text-[clamp(2.25rem,5vw,4.25rem)] font-semibold leading-[1.02] tracking-tight">
          Cliente que some não reclama.
          <span className="mt-2 block text-white/55">Só deixa de voltar.</span>
        </h2>
        <div className="mt-14 grid gap-8 sm:grid-cols-3">
          {SCENES.map((scene) => (
            <article key={scene.title} className="flex flex-col">
              {scene.visual}
              <h3 className="mt-5 font-display text-lg font-semibold">{scene.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60">“{scene.line}”</p>
            </article>
          ))}
        </div>
      </SiteContainer>
    </section>
  );
}
